"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncModal;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("./index"));
var _asyncComponent = require("../../async-component");
/**
 * AsyncModal Component.
 *
 * @param {Object} props React props
 * @param {string} props.sitecoreID Sitecore ID
 * @param {string} props.retryText Retry text
 * @param {Function} props.moduleLoader Module loader
 * @returns {React.ReactElement} ComponentName Component
 * @public
 */

function AsyncModal({
  sitecoreID,
  retryText,
  moduleLoader,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(_index.default, rest, /*#__PURE__*/_react.default.createElement(_asyncComponent.AsyncModule, {
    sitecoreID: sitecoreID,
    retryText: retryText,
    moduleLoader: moduleLoader
  }));
}
AsyncModal.propTypes = {
  sitecoreID: _propTypes.default.string,
  retryText: _propTypes.default.string,
  moduleLoader: _propTypes.default.func,
  ..._index.default.propTypes
};